import { render, staticRenderFns } from "./ReturnToTopButton.vue?vue&type=template&id=11e37613&scoped=true&"
import script from "./ReturnToTopButton.vue?vue&type=script&lang=js&"
export * from "./ReturnToTopButton.vue?vue&type=script&lang=js&"
import style0 from "./ReturnToTopButton.vue?vue&type=style&index=0&id=11e37613&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e37613",
  null
  
)

export default component.exports